import React from 'react';
import { Row, Col } from 'antd';
import { Label } from 'components';

const PageTitle = ({ message, pageName }) => {
  return (
    <Row className={`page-title-row ${pageName}-title-row`}>
      <Col span={24} className={`page-title-col ${pageName}-title-col`}>
        <Label
          label={message}
          labelClassName={`page-title-label ${pageName}-title-label`}
        />
      </Col>
    </Row>
  );
};

export default PageTitle;